import { Component, inject, Input, OnInit } from '@angular/core';
import { GlobalPageHeaderComponent } from '../../../global-page-header/global-page-header.component';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { IProduct } from '../../../../services/ecosystems/products/IProduct';
import { ReactiveFormsModule } from '@angular/forms';
import {
  AssistanceApi,
  AssistanceCase,
  AssistanceReport,
} from '../../../../apis/assistance.api';
import { EdroNetworkManager } from '../../../../services/ecosystems/manager/edro-network-manager';
import { IDeviceTableNode } from '../../../../services/ecosystems/products/IDeviceTable';
import { LinkComponent } from '../../../link/link.component';
import { environment } from '../../../../../environments/environment';
import { brandOverride } from '../../../../services/ecosystems/ECoSystemsHelper';

@Component({
  selector: 'app-pool-installation-assistance',
  templateUrl: './pool-installation-assistance.component.html',
  styleUrls: ['./pool-installation-assistance.component.scss'],
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    IonFooter,
    IonLabel,
    IonItem,
    IonList,
    ReactiveFormsModule,
    TranslatePipe,
    LinkComponent,
  ],
})
export class PoolInstallationAssistanceComponent implements OnInit {
  private modalController = inject(ModalController);
  private assistanceApi = inject(AssistanceApi);
  private edroNerworkManager = inject(EdroNetworkManager);

  @Input() productClass: IProduct | null = null;
  @Input() step: number = 0;

  assistanceReports: AssistanceReport[] = [];

  showAssistanceReports: AssistanceReport[] = [];
  showAssistanceCase: AssistanceCase | null = null;

  ngOnInit() {
    const deviceTableNode = this.productClass?.getProductDeviceTableFromPool(
      this.edroNerworkManager.getPoolContext().pool!,
    ) as IDeviceTableNode;

    this.assistanceApi
      .getProductAssistance(
        this.productClass!.manufacturerName!,
        this.productClass!.modelIdentifier!,
        deviceTableNode!.firmwareVersion!,
      )
      .then((res) => {
        this.assistanceReports = res;
        this.showAssistanceReports = res;
      })
      .catch(() => {
        this.assistanceReports = [];
        this.showAssistanceReports = [];
      });
  }

  async dismissModal() {
    this.modalController.dismiss();
  }

  goTo(report: AssistanceReport) {
    console.log(report);

    if (report.elements) {
      this.showAssistanceReports = report.elements as AssistanceReport[];
    } else {
      this.showAssistanceCase = report as any;
    }

    this.step = this.step + 1;
  }

  clear() {
    this.showAssistanceReports = this.assistanceReports;
    this.step = 0;
  }

  protected readonly environment = environment;
  protected readonly brandOverride = brandOverride;
}
